"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toCII = exports.toUBL = exports.toCanonicalJson = exports.StubAccessPoint = void 0;
/**
 * Dormant connector used everywhere until an accredited network is available.
 * It performs no network I/O and never changes app behaviour.
 */
class StubAccessPoint {
    constructor() {
        this.id = 'stub-not-live';
    }
    async clear() {
        return { status: 'not-live', accessPoint: this.id };
    }
    async report() {
        return { accepted: false };
    }
}
exports.StubAccessPoint = StubAccessPoint;
/**
 * Canonical structured serialisation available TODAY. JSON is a valid structured,
 * machine-readable representation (SARS explicitly references XML *and* JSON), and
 * this is stable regardless of the eventual CIUS. Use it for storage/export now.
 */
function toCanonicalJson(invoice) {
    return JSON.stringify(invoice, null, 2);
}
exports.toCanonicalJson = toCanonicalJson;
const PENDING = 'Serialisation to this syntax is pending the SARS CIUS (Phase 2, 2027/28). ' +
    'The e-invoice object is already EN16931-shaped, so this is a mapping-only task.';
/** Peppol PINT BIS / UBL 2.1 XML — stubbed until the SARS CIUS is published. */
function toUBL(_invoice) {
    throw new Error(`toUBL: ${PENDING}`);
}
exports.toUBL = toUBL;
/** UN/CEFACT Cross-Industry Invoice XML — stubbed until the SARS CIUS is published. */
function toCII(_invoice) {
    throw new Error(`toCII: ${PENDING}`);
}
exports.toCII = toCII;
